import { Event, EventType } from '@graphql/__generated/graphql'

export enum CONFIG_OPTIONS {
  SHOW_FULL_REGISTRATION_OPTIONS,
  SHOW_ACCOUNT_PROMPT,
  SHOW_VISIBLE_REGISTRATION_OPT_IN,
  SHOW_ATTENDEE_BOX,
  ALLOW_DIRECT_DEBIT,
  SHOW_GOOGLE_ADS,
  SHOW_QUICK_REGISTRATION_OPTIONS,
}

// NOTE: Temporary config options
export const getRegistrationConfig = (
  opt: CONFIG_OPTIONS,
  event: Partial<Event> | undefined
): boolean => {
  // console.log(`[RegistrationConfig]: `, { opt, event })
  if (!event) return true
  const isInPerson = event.event?.eventType === EventType.InPerson
  // const isOnline = event.event?.eventType === EventType.Online

  const orgName = event?.event?.organizationName?.toLowerCase() ?? ''
  switch (opt) {
    case CONFIG_OPTIONS.SHOW_ACCOUNT_PROMPT:
      if (orgName.includes('sussex')) return false
      if (orgName.includes('448 studio')) return false
      break

    case CONFIG_OPTIONS.SHOW_FULL_REGISTRATION_OPTIONS:
      if (orgName.includes('sussex')) return false
      if (orgName.includes('448 studio')) return false
      break

    case CONFIG_OPTIONS.SHOW_VISIBLE_REGISTRATION_OPT_IN:
      if (orgName.includes('sussex')) return true
      if (orgName.includes('forumm')) return true
      // if (orgName.includes('imaginary friends')) return true
      if (event.eventId === '16caaaed-dc0d-44d7-936d-0a590dfef429') return true
      return false

    case CONFIG_OPTIONS.ALLOW_DIRECT_DEBIT:
      if (orgName.includes('sussex')) return true
      if (orgName.includes('448 studio')) return true
      if (orgName.includes('forumm')) return true
      return false

    case CONFIG_OPTIONS.SHOW_ATTENDEE_BOX:
      if (orgName.includes('sussex')) return true
      // if (orgName.includes('imaginary friends')) return true
      if (orgName.includes('university of glasgow') && isInPerson) return true
      if (event.eventId === '16caaaed-dc0d-44d7-936d-0a590dfef429') return true
      if (event.eventId === 'e172670e-a062-4f05-9e33-b334a57fff93') return true
      return false

    case CONFIG_OPTIONS.SHOW_QUICK_REGISTRATION_OPTIONS:
      if (event.eventId === '236e01cf-bcfb-41e0-94e9-4c173e2e16f4') return false
      if (event.eventId === '59080128-59d6-4164-a824-0e48b01ef75f') return false
      return true
  }
  return true
}

export const getOrganisationConfig = (
  opt: CONFIG_OPTIONS,
  orgName: string | undefined
): boolean => {
  // console.log(`[OrganisationConfig]: `, { opt, orgName })
  if (!orgName) return true
  const sanitisedOrgName = orgName.toLowerCase()

  switch (opt) {
    case CONFIG_OPTIONS.SHOW_GOOGLE_ADS:
      if (sanitisedOrgName.includes('sussex')) return false
      return true
  }
  return true
}
